import '../../index.css'; 
import ppimg from"@/assets/images/pp.png"
const WordsFromCeo = () => {
    return (
        <>
        <div className='responsive-padding-home'>
        <div className="font-extrabold text-custom-secolor flex flex-wrap justify-center ">
            <h2 className="text-[clamp(1.5rem,2vw,3rem)] font-extrabold tracking-normal text-custom-secolor text-center mb-4">Words From Our Beloved Founder</h2>
            <div className="grid grid-cols-11 items-start px-8  flex flex-wrap lg:mt-16 mt-4 ">
            <div className="col-span-11 lg:col-span-5 lg:ml-32 lg:mr-8 mx-auto">
              <figure>
                <img
                  className="w-1/2 sm:w-3/4 md:w-2/4 lg:w-full max-w-md h-auto rounded-lg mb-4 lg:mb-0 mx-auto"
                  src={ppimg}
                  alt="Shankar Karki, founder of Sheel Waterproofing"
                />
              </figure>
            </div>

            <div className="col-span-11 lg:col-start-6 lg:col-span-5 text-custom-darkblue">
              <p className="lg:text-md text-justify tracking-tight break-normal leading-relaxed content-home">
                Dear Valued Customers, Welcome to 
                <span className="global-span-class"> Sheel Waterproofing</span> where excellence meets waterproofing expertise. As the Founder, 
                I'm proud to lead a team dedicated to providing cutting-edge solutions for your waterproofing needs.
                <br /><br />
                Our commitment to quality, innovation, and customer satisfaction is unmatched. Explore our website to discover how Sheel Waterproofing can protect your investments and ensure watertight future for your projects.
              </p>

              {/* ✅ Move this outside the <p> tag */}
              <div className="xl:mt-[clamp(1rem,5vw,20rem)] mt-4">
                <p className="content-home text-custom-secolor">
                Best regards,
                </p>
                <span className="text-[clamp(1rem,2vw,1.5rem)] text-custom-secolor font-bold leading-relaxed tracking-tight">
                   Late Shankar Karki (Founder)
                  <br /> Sheel Waterproofing Nepal Pvt. Ltd.
                </span>
              </div>
            </div>

            </div>
        </div>
        </div>
        </>

    )
}

export default WordsFromCeo